import { render, staticRenderFns } from "./AttachNoteModal.vue?vue&type=template&id=3711802d&scoped=true&"
import script from "./AttachNoteModal.vue?vue&type=script&lang=js&"
export * from "./AttachNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3711802d",
  null
  
)

export default component.exports